export enum AppHeaderLabels {
  VIEW_INVOICE = 'View Invoice',
  RELEASE_INVOICES = 'Release Invoices',
  RESEND_INVOICES = 'Re-Send Invoices',
  RFC_MANAGEMENT = 'RFC Management'
}
